import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'locumsnest-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalComponent {
  show = input<boolean>();
  title = input<string>();
  showCloseButton = input(true);
  showLine = input(true);

  closed = output<void>();

  closeModal() {
    this.closed.emit();
  }
}
